import { Middleware } from 'redux'

import { request as requestAction } from '@/store/actions'
import { REQUEST_LIMIT } from '@/store/actionTypes'

import { RootState } from '..'

/**
 * Redux middleware that initiates an API request using the details of the action. Limits the number of concurrent
 * requests being executed at any given time.
 */
const requestLimitMiddleware: Middleware<{}, RootState> = store => next => async action => {
  if (action.type !== REQUEST_LIMIT) {
    return next(action)
  }

  const limit = action.limit || 1
  const promises = new Set()

  return action.requests.map(async (request: Parameters<typeof requestAction>) => {
    while (promises.size >= limit) {
      await Promise.race(promises)
    }

    const promise = store.dispatch(requestAction(...request))

    promises.add(promise)
    await promise
    promises.delete(promise)
  })
}

export default requestLimitMiddleware
